export default { 
  type: 'number', 
  label: 'Número',
  shape: 'diamond'
}